export const PENDING_HOLDS_STORAGE_KEY = "ubsaapp_schedule_pending_holds";
const SLOT_MS = 30 * 60 * 1000;

export const toLocalYmd = (date) => {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
};

export const forEachSlotInRange = (startDate, endDate, onSlot) => {
  const start = new Date(startDate);
  const end = new Date(endDate);
  if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime()) || end <= start) return;

  const cursor = new Date(start);
  cursor.setSeconds(0, 0);
  cursor.setMinutes(Math.floor(cursor.getMinutes() / 30) * 30);

  while (cursor < end) {
    const dateYmd = toLocalYmd(cursor);
    const timeKey = `${String(cursor.getHours()).padStart(2, "0")}:${String(cursor.getMinutes()).padStart(2, "0")}`;
    onSlot(dateYmd, timeKey);
    cursor.setTime(cursor.getTime() + SLOT_MS);
  }
};

export const readRoomPendingHolds = (roomId) => {
  if (!roomId) return {};
  try {
    const data = JSON.parse(localStorage.getItem(PENDING_HOLDS_STORAGE_KEY) || "{}");
    return data[String(roomId)] || {};
  } catch {
    return {};
  }
};

export const writeRoomPendingHold = (roomId, date, time) => {
  if (!roomId || !date || !time) return;
  try {
    const data = JSON.parse(localStorage.getItem(PENDING_HOLDS_STORAGE_KEY) || "{}");
    const roomKey = String(roomId);
    if (!data[roomKey]) data[roomKey] = {};
    data[roomKey][`${date}|${time}`] = { date, time };
    localStorage.setItem(PENDING_HOLDS_STORAGE_KEY, JSON.stringify(data));
  } catch {
    // ignore storage errors
  }
};

export const removeRoomPendingHold = (roomId, date, time) => {
  if (!roomId || !date || !time) return;
  try {
    const data = JSON.parse(localStorage.getItem(PENDING_HOLDS_STORAGE_KEY) || "{}");
    const roomKey = String(roomId);
    if (!data[roomKey]) return;
    delete data[roomKey][`${date}|${time}`];
    if (Object.keys(data[roomKey]).length === 0) delete data[roomKey];
    localStorage.setItem(PENDING_HOLDS_STORAGE_KEY, JSON.stringify(data));
  } catch {
    // ignore storage errors
  }
};

export const syncPendingHoldKeysFromStorage = (roomId, targetSet) => {
  const holds = readRoomPendingHolds(roomId);
  Object.keys(holds).forEach((key) => targetSet.add(key));
};

export const persistPendingRange = (roomId, startDate, endDate) => {
  if (!roomId) return;
  forEachSlotInRange(startDate, endDate, (dateYmd, timeKey) => {
    writeRoomPendingHold(roomId, dateYmd, timeKey);
  });
};

export const clearPendingRange = (roomId, startDate, endDate) => {
  if (!roomId) return;
  forEachSlotInRange(startDate, endDate, (dateYmd, timeKey) => {
    removeRoomPendingHold(roomId, dateYmd, timeKey);
  });
};
